import { RememberPasswordAlert } from './remember-password.jsx';

export { RememberPasswordAlert };
export default RememberPasswordAlert;
